module.exports = __webpack_public_path__ + "static/media/OpenSans-SemiBold.c35a5d83.ttf";